import React, { Component } from 'react'
import { createFragmentContainer } from 'react-relay'
import graphql from 'babel-plugin-relay/macro' 

import ArticleSection from './article-section'

const connectRelay = ArticleSection => class extends Component {

    render() {
        const { routeResolver } = this.props.context
        const categories = this.props.home.categories.map(c =>
            ({ ...c, link: routeResolver.category.get(c.slug) })
        )
        const articles = this.props.home.categoriesContent.map(a => {
            const group = a.city || a.category
            return {
                ...a,
                link: group && routeResolver.article.get(group.slug, a.slug)
            }
        })

        return (
            <ArticleSection
                title="Playbook"
                classPrefix="category"
                link={routeResolver.categoryList.get()}
                dropdownItems={categories}
                articles={articles}
                right promotion={{
                    action: 'Explore',
                    title: this.props.home.categoriesPromoted.name,
                    link: routeResolver.category.get(this.props.home.categoriesPromoted.slug),
                    color: this.props.home.categoriesPromoted.color,
                    image: this.props.home.categoriesPromotedPicture,
                }}
            />
        )
    }
}

export default createFragmentContainer(
    connectRelay(ArticleSection),
    graphql`
        fragment categoriesSection_home on Home {
            categories {
                slug
                name
            }
            categoriesContent {
                slug
                title
                caption
                readingTime
                picture
                author {
                    firstname
                    lastname
                }
                category {
                    slug
                    name
                    color
                }
            }
            categoriesPromoted {
                slug
                name
                color
            }
            categoriesPromotedPicture
        }
    `
)
